import { createGLBModel } from "./GLBModel";

import { computeCurvatureDirections } from "../../geometry/computeCurvatureDirections";

import milkTruckUrl from "../../../../assets/models/CesiumMilkTruck.glb";

const MilkTruckModel = createGLBModel({
  id: "milk-truck",

  name: "Milk Truck",

  url: milkTruckUrl,

  transform: {
    position: [0, 0, 0],

    rotation: [0, 0, 0],

    scale: 1.0,
  },

  capabilities: {
    normals: true,
    uv: true,
    tangents: false,
  },

  geometryProcessor: computeCurvatureDirections,
});

export default MilkTruckModel;
